import React, { useState } from "react";

function CloseIcon(props) {
  const { handleClick, extraClasses, size = "small", wrapperElement = "div", ...otherProps } = props || {};
  const [WrapperComponent] = useState(wrapperElement);

  return (
    <WrapperComponent
      {...otherProps}
      onClick={handleClick}
      role="img"
      className={`mls-o-svg transform ${extraClasses ? extraClasses : ""}`}>
      <span className={`oc-o-icon--close-button icon-svg fa-icon-svg fa-icon-svg--${size}`}>
        <svg viewBox="0 0 12 12">
          <path
            d="M1.652 10.26l8.608-8.608m-8.608 0l8.608 8.608"
            stroke="#151516"
            strokeWidth={1.2}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
          />
        </svg>
      </span>
    </WrapperComponent>
  );
}

// eslint-disable-next-line no-func-assign
CloseIcon = React.memo(CloseIcon);

export default CloseIcon;
